<template>
  <div>
  <v-dialog
    v-model="aperto"
    width="1400"
    scrollable
    :persistent="chiusura_in_corso"
    @click:outside="chiudi"
  >
    <!-- Altezza fissa: il dialog è centrato verticalmente, quindi senza di
         essa piegare i gruppi ne cambia l'altezza e trascina i comandi
         sotto il puntatore. -->
    <v-card v-if="prenotazione" height="90vh">
      <v-card-title class="grey--text text-subtitle-1">
        Prenotazione crisantemi
        <v-chip x-small class="ml-3" color="green lighten-5">{{ prenotazione.anno }}</v-chip>
        <v-spacer />
        <IndicatoreSalvataggio />
      </v-card-title>

      <v-card-subtitle class="pb-0">
        <v-row align="center" class="mt-0">
          <v-col cols="4">
            <div class="text-h6">
              <v-icon class="mr-2">mdi-account</v-icon>
              {{ cliente.numero }} — {{ cliente.nome }}
            </div>
            <!-- Modificabili in loco: il testo stesso è l'attivatore, così
                 la testata non si riempie di bottoni. -->
            <div class="text-caption grey--text ml-8 d-flex align-center">
              <v-menu v-model="menu_ritiro" offset-y>
                <template v-slot:activator="{ on }">
                  <span
                    class="modificabile"
                    :class="prenotazione.ritiro ? 'green--text' : 'blue--text'"
                    v-on="on"
                  >
                    {{ prenotazione.ritiro ? "Ritiro" : "Consegna" }}
                  </span>
                </template>
                <v-list dense>
                  <v-list-item @click="imposta_ritiro(true)">
                    <v-list-item-title class="green--text">Ritiro</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="imposta_ritiro(false)">
                    <v-list-item-title class="blue--text">Consegna</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <span class="mx-2">·</span>

              <v-menu v-model="menu_data" :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on }">
                  <span class="modificabile" v-on="on">
                    presunta
                    <b :class="prenotazione.ts_consegna_presunta ? '' : 'font-italic'">
                      {{ data_presunta }}
                    </b>
                  </span>
                </template>
                <v-date-picker
                  :value="data_presunta_iso"
                  locale="it-it"
                  first-day-of-week="1"
                  @change="imposta_data_presunta"
                />
              </v-menu>
            </div>
          </v-col>

          <v-col cols="3">
            <span class="grey--text text-caption mr-2">Carrelli</span>
            <span class="text-h6">{{ cc }}</span>
            <span class="grey--text text-caption mx-2">Valore</span>
            <span class="text-h6">{{ valore }} €</span>
          </v-col>

          <v-col cols="2">
            <v-switch
              v-model="mostra_tutto"
              inset
              hide-details
              dense
              label="Mostra tutto"
              class="mt-0"
            />
          </v-col>

          <v-col cols="3" class="text-right">
            <SelettoreProdottoColori
              :filtro="non_crisantemo"
              segnaposto="Cerca un prodotto non crisantemo..."
              @conferma="aggiungi_extra"
            >
              <template v-slot:activator="{ on }">
                <v-btn small outlined color="green" class="mr-2" v-on="on">
                  <v-icon left small>mdi-plus</v-icon>Prodotto
                </v-btn>
              </template>
            </SelettoreProdottoColori>
            <v-btn
              small
              outlined
              color="purple"
              :loading="consegna_in_creazione"
              @click="aggiungi_consegna"
            >
              <v-icon left small>mdi-plus</v-icon>Consegna
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="mt-3" />
      </v-card-subtitle>

      <v-card-text>
        <GrigliaColori
          :prenotazione="prenotazione"
          :mostra-tutto="mostra_tutto"
          :voce-evidenziata="voceEvidenziata"
          :prodotto-evidenziato="prodottoEvidenziato"
          @alterna-tutto="propaga_piegatura"
        >
          <template v-slot:testata-consegna="{ consegna }">
            <TestataConsegna
              :id-prenotazione="prenotazione.id"
              :consegna="consegna"
            />
          </template>
        </GrigliaColori>

        <!-- Prodotti non crisantemo aggiunti alla prenotazione -->
        <template v-if="prodotti_extra.length">
          <v-divider class="my-6" />
          <GrigliaColori
            ref="griglia_extra"
            :prenotazione="prenotazione"
            :prodotti="prodotti_extra"
            :intestazione="false"
          />
        </template>

        <v-row class="mt-6">
          <v-col cols="8">
            <v-textarea
              v-model="nota"
              label="Note"
              outlined
              rows="2"
              auto-grow
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn outlined color="purple" :loading="stampa_in_corso" @click="stampa">
          <v-icon left>mdi-printer</v-icon>Stampa
        </v-btn>
        <v-btn text color="grey" :loading="chiusura_in_corso" @click="chiudi">
          Chiudi
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>

  <!-- Fuori dal v-dialog: annidato dentro finirebbe sotto l'overlay e gli
       errori resterebbero invisibili. -->
  <v-snackbar v-model="avviso" color="red" text outlined top timeout="5000">
    <v-icon color="red" class="mr-2">mdi-alert</v-icon>{{ messaggio }}
  </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import printer from "@/service/printer";
import GrigliaColori from "./GrigliaColori.vue";
import TestataConsegna from "./TestataConsegna.vue";
import IndicatoreSalvataggio from "./IndicatoreSalvataggio.vue";
import SelettoreProdottoColori from "@/components/Comune/SelettoreProdottoColori.vue";

/**
 * Dettaglio di una prenotazione crisantemi.
 *
 * Riceve solo l'id e legge dallo store: così le modifiche via socket e le
 * risposte del server si riflettono senza che il chiamante debba ripassare
 * l'oggetto aggiornato.
 */
export default {
  components: {
    GrigliaColori,
    TestataConsegna,
    IndicatoreSalvataggio,
    SelettoreProdottoColori,
  },

  props: {
    idPrenotazione: { type: String, default: null },
    voceEvidenziata: { type: String, default: null },
    prodottoEvidenziato: { type: String, default: null },
  },

  data() {
    return {
      aperto: false,
      mostra_tutto: false,
      nota: "",
      consegna_in_creazione: false,
      stampa_in_corso: false,
      chiusura_in_corso: false,
      avviso: false,
      messaggio: "",
      menu_ritiro: false,
      menu_data: false,
    };
  },

  computed: {
    prenotazione() {
      if (!this.idPrenotazione) return null;
      return this.$store.getters["crisantemi/by_id"](this.idPrenotazione);
    },

    cliente() {
      const c = this.$store.getters.get_cliente_by_iva(
        this.prenotazione.cliente
      );
      return c || { numero: "?", nome: this.prenotazione.cliente };
    },

    data_presunta() {
      return this.prenotazione.ts_consegna_presunta
        ? moment.unix(this.prenotazione.ts_consegna_presunta).format("ddd D MMMM")
        : "non specificata";
    },

    data_presunta_iso() {
      // Senza data il calendario si apre su ottobre dell'anno di riferimento,
      // dove cade la campagna, invece che sul mese corrente.
      return this.prenotazione.ts_consegna_presunta
        ? moment.unix(this.prenotazione.ts_consegna_presunta).format("YYYY-MM-DD")
        : `${this.prenotazione.anno}-10-15`;
    },

    cc() {
      return this.$store.getters["crisantemi/cc"]({
        id_prenotazione: this.idPrenotazione,
      }).toFixed(1);
    },

    valore() {
      return this.$store.getters["crisantemi/valore"](
        this.idPrenotazione
      ).toFixed(2);
    },

    /**
     * Prodotti non crisantemo che compaiono nella prenotazione. Solo quelli
     * già presenti: qui "mostra tutto" significherebbe l'intero catalogo.
     */
    prodotti_extra() {
      if (!this.prenotazione) return [];
      const ids = new Set(
        (this.prenotazione.prodotti || []).map((p) => p.id_prodotto)
      );
      (this.prenotazione.consegne || []).forEach((c) =>
        (c.prodotti || []).forEach((p) => ids.add(p.id_prodotto))
      );
      return this.$store.getters.get_lista_prodotti_raw.filter(
        (p) => ids.has(p.id) && p.sotto_categoria != "Crisantemo"
      );
    },
  },

  watch: {
    // La nota è editata localmente e si riallinea solo su cambio di
    // prenotazione o all'apertura: seguire lo store a ogni aggiornamento
    // ripopolerebbe il campo appena svuotato.
    idPrenotazione: "sincronizza_nota",

    aperto(adesso) {
      if (!adesso) return;
      this.sincronizza_nota();
      this.carica_ordini();
    },

    nota(valore) {
      if (!this.aperto || !this.prenotazione) return;
      if ((this.prenotazione.nota || "") === valore) return;
      // Il buffer dello store accumula e spedisce: qui nessun debounce.
      this.$store.dispatch("crisantemi/imposta_nota_prenotazione", {
        id_prenotazione: this.prenotazione.id,
        nota: valore,
      });
    },
  },

  methods: {
    apri() {
      this.aperto = true;
    },

    imposta_data_presunta(iso) {
      this.menu_data = false;
      this.$store
        .dispatch("crisantemi/imposta_data_presunta", {
          id: this.prenotazione.id,
          ts: moment(iso).format("X"),
        })
        .catch((err) => this.segnala("Data non aggiornata", err));
    },

    imposta_ritiro(ritiro) {
      this.menu_ritiro = false;
      this.$store
        .dispatch("crisantemi/cambia_ritiro", {
          id: this.prenotazione.id,
          ritiro,
        })
        .catch((err) => this.segnala("Modalità non aggiornata", err));
    },

    /**
     * Il bottone vive nell'intestazione della griglia crisantemi, ma il
     * comando riguarda tutto il dettaglio: la sezione extra non ha
     * intestazione e quindi nessun bottone proprio.
     */
    propaga_piegatura(chiudere) {
      const extra = this.$refs.griglia_extra;
      if (!extra) return;
      if (chiudere) extra.comprimi_tutto();
      else extra.espandi_tutto();
    },

    // I crisantemi hanno già la loro griglia: qui si cerca solo il resto.
    non_crisantemo(prodotto) {
      return prodotto.sotto_categoria != "Crisantemo";
    },

    /**
     * Le quantità confermate entrano nel buffer come qualsiasi altra cella:
     * un prodotto con otto colori parte in una richiesta sola.
     */
    aggiungi_extra({ prodotto, colori }) {
      colori.forEach((c) => {
        this.$store.dispatch("crisantemi/imposta_voce", {
          id_prenotazione: this.prenotazione.id,
          id_consegna: null,
          id_prodotto: prodotto.id,
          id_voce: c.id_voce,
          tipo: c.tipo,
          qta: c.qta,
        });
      });
    },

    /**
     * Ordini generati dalle consegne: servono alla testata di colonna per
     * mostrare numero e stato di conteggio. Si caricano all'apertura e solo
     * quelli non ancora in store.
     */
    carica_ordini() {
      if (!this.prenotazione) return;
      (this.prenotazione.consegne || [])
        .filter((c) => c.id_ordine_creato)
        .filter((c) => !this.$store.getters.get_ordine_by_id(c.id_ordine_creato))
        .forEach((c) => {
          this.$store
            .dispatch("fetch_ordine_by_id", c.id_ordine_creato)
            .catch(() => {});
        });
    },

    sincronizza_nota() {
      this.nota = this.prenotazione ? this.prenotazione.nota || "" : "";
    },

    async chiudi() {
      // Il buffer sopravvive alla chiusura, ma lasciare il dialog con
      // modifiche non spedite è il modo migliore per dimenticarsele.
      this.chiusura_in_corso = true;
      try {
        await this.$store.dispatch("crisantemi/flush");
        this.aperto = false;
        this.$emit("chiuso");
      } catch (err) {
        this.segnala("Modifiche non salvate, il dialog resta aperto", err);
      } finally {
        this.chiusura_in_corso = false;
      }
    },

    /** Messaggio d'errore che dice cosa è successo davvero. */
    segnala(cosa, err) {
      const stato = err && err.response ? err.response.status : null;
      if (stato === 404) {
        this.messaggio = `${cosa}: endpoint non trovato (404). Il server è aggiornato?`;
      } else if (stato) {
        this.messaggio = `${cosa}: errore ${stato}.`;
      } else {
        this.messaggio = `${cosa}: server non raggiungibile.`;
      }
      this.avviso = true;
    },

    async aggiungi_consegna() {
      this.consegna_in_creazione = true;
      try {
        await this.$store.dispatch(
          "crisantemi/crea_consegna",
          this.prenotazione.id
        );
      } catch (err) {
        this.segnala("Consegna non creata", err);
      } finally {
        this.consegna_in_creazione = false;
      }
    },

    async stampa() {
      this.stampa_in_corso = true;
      try {
        // Il PDF è renderizzato dal server sui dati salvati.
        await this.$store.dispatch("crisantemi/flush");
        printer.print_pdf_ordine_crisantemi(this.prenotazione.id);
      } catch (err) {
        this.segnala("Stampa annullata, salvataggio non riuscito", err);
      } finally {
        this.stampa_in_corso = false;
      }
    },

  },
};
</script>

<style scoped>
/* Testo che è anche un comando: la sottolineatura tratteggiata lo dichiara
   senza aggiungere un bottone alla testata. */
.modificabile {
  cursor: pointer;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
}
.modificabile:hover {
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
</style>
